var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangeView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 1H1.66667C1.29848 1 1 1.29848 1 1.66667V5C1 5.36819 1.29848 5.66667 1.66667 5.66667H5C5.36819 5.66667 5.66667 5.36819 5.66667 5V1.66667C5.66667 1.29848 5.36819 1 5 1Z",
    stroke: "#171E3C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.33325H1.66667C1.29848 8.33325 1 8.63173 1 8.99992V12.3333C1 12.7014 1.29848 12.9999 1.66667 12.9999H5C5.36819 12.9999 5.66667 12.7014 5.66667 12.3333V8.99992C5.66667 8.63173 5.36819 8.33325 5 8.33325Z",
    stroke: "#171E3C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3335 1H9.00016C8.63197 1 8.3335 1.29848 8.3335 1.66667V5C8.3335 5.36819 8.63197 5.66667 9.00016 5.66667H12.3335C12.7017 5.66667 13.0002 5.36819 13.0002 5V1.66667C13.0002 1.29848 12.7017 1 12.3335 1Z",
    stroke: "#171E3C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3335 8.33325H9.00016C8.63197 8.33325 8.3335 8.63173 8.3335 8.99992V12.3333C8.3335 12.7014 8.63197 12.9999 9.00016 12.9999H12.3335C12.7017 12.9999 13.0002 12.7014 13.0002 12.3333V8.99992C13.0002 8.63173 12.7017 8.33325 12.3335 8.33325Z",
    stroke: "#171E3C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeView);
export default __webpack_public_path__ + "static/media/change_view.6f526160010c320465ee37f9dca69a0a.svg";
export { ForwardRef as ReactComponent };